import React, { useRef, useEffect } from 'react';
import { Restrictions } from '@shared/ui/Restrictions';
import { useTheme } from '../../../../../theme';
import { Checkbox, Tooltip } from '../../../../../BaseComponents';
import { FormControlLabel } from '@mui/material';
import { SafeHtml } from '@shared/ui';
const RestrictionsStep = ({ restrictions, consentText, tooltipText, showTooltip, isAccepted, onAcceptChange }) => {
    const { RestrictionsStep: css } = useTheme('Entities').Restrictions;
    const ref = useRef(null);
    useEffect(() => {
        if (ref.current && showTooltip) {
            ref.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [showTooltip]);
    return (React.createElement("div", { className: css.root },
        React.createElement("div", { className: css.container },
            React.createElement("div", { className: css.restrictions }, restrictions.map((restriction, index) => (React.createElement(Restrictions, Object.assign({ key: index }, restriction))))),
            React.createElement("div", { className: css.checkbox__wrapper, ref: ref },
                React.createElement(FormControlLabel, { classes: { root: css.checkbox__root }, checked: isAccepted, control: React.createElement(Tooltip, { open: showTooltip, title: tooltipText },
                        React.createElement(Checkbox, { required: showTooltip, onChange: onAcceptChange })), label: React.createElement("span", { className: css.checkbox__label },
                        React.createElement(SafeHtml, { tag: "span", html: consentText })) })))));
};
export default RestrictionsStep;
